export default function Marquee({ items }) {
  const Row = ({ hidden }) => (
    <div aria-hidden={hidden || undefined} className="flex shrink-0 items-center">
      {items.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="whitespace-nowrap px-7 font-display text-[13px] font-semibold uppercase tracking-[0.2em] text-brand-navy/70">
            {item}
          </span>
          <span className="relative flex h-2 w-2">
            <span className="absolute inset-0 animate-sonar rounded-full bg-brand-blue/70" />
            <span className="relative h-2 w-2 rounded-full bg-brand-blue" />
          </span>
        </span>
      ))}
    </div>
  );
  return (
    <div data-testid="brand-marquee" className="overflow-hidden border-y border-brand-line bg-brand-mist py-4">
      <div className="flex w-max animate-ticker">
        <Row />
        <Row hidden />
      </div>
    </div>
  );
}